module.exports = __webpack_public_path__ + "img/hero-building.6f6b2c2c.jpg";